import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import OkrAlignmentComp from './components/okr/okr-alignmnet';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

function renderFullAlighnmentPage(data) {
  const mountId = document.getElementById('goal-align-page');
  if (mountId) {
    ReactDOM.render(
      <Suspense fallback="loading...">
        <I18nextProvider i18n={i18n}>
          <OkrAlignmentComp {...data} />
        </I18nextProvider>
      </Suspense>,
      mountId
    );
  }
}

window.renderFullAlighnmentPage = renderFullAlighnmentPage;
